// extracted by mini-css-extract-plugin
export default {"redirection-table":"RedirectionTable_redirection-table__o3i5b"};